/* Choose guide controls. Original quiz and comparison state remain owned by Vue. */
(function () {
  'use strict';
  if (window.NarwalInterface) return;
  window.NarwalInterface = { version: 1 };
  var trigger = null, previousOverflow = '', closeTimer;
  function shown(node) { return !!(node && node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden'); }
  function quiz() { return document.querySelector('.fullscreen-quiz-wrap.show'); }
  function restore() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      if (quiz()) return;
      document.body.style.overflow = previousOverflow;
      if (trigger && trigger.isConnected) trigger.focus({ preventScroll: true });
    }, 330);
  }
  document.addEventListener('click', function (event) {
    var open = event.target.closest('[data-nwb-choose-quiz]');
    if (open && typeof $narwal !== 'undefined' && typeof $narwal.emit === 'function') {
      trigger = open; previousOverflow = document.body.style.overflow;
      $narwal.emit('ndev_prime_popup_quiz_L9iwdD');
      requestAnimationFrame(function () { var dialog = quiz(); if (dialog) dialog.focus({ preventScroll: true }); });
    }
    var jump = event.target.closest('[data-nwb-choose-section]');
    if (jump) {
      var ownerSection = jump.closest('.shopify-section'), main = ownerSection && ownerSection.parentElement, sections = main && Array.from(main.children).filter(function (node) { return node.classList.contains('shopify-section'); });
      var section = sections && sections[Number(jump.dataset.nwbChooseSection) - 1];
      if (section) window.scrollTo({ top: section.getBoundingClientRect().top + window.scrollY - 80, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    if (event.target.closest('.fullscreen-quiz-wrap .close')) restore();
  });
  document.addEventListener('keydown', function (event) {
    var dialog = quiz();
    if (dialog && event.key === 'Escape') { event.preventDefault(); var close = dialog.querySelector('.close'); if (close) close.click(); return; }
    if (dialog && event.key === 'Tab') {
      var controls = Array.from(dialog.querySelectorAll('a[href],button,input,select,textarea,[tabindex="0"]')).filter(function (node) { return shown(node) && !node.disabled && node.getAttribute('aria-disabled') !== 'true'; });
      var first = controls[0], last = controls[controls.length - 1];
      if (!first) { event.preventDefault(); dialog.focus(); }
      else if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
    }
    var control = event.target.closest('.ndev-prime-popup-quiz [role="button"],.ndev-main-compare [role="button"],.ndev-dx9-compare [role="button"]');
    if (control && !/^(BUTTON|A|INPUT|SELECT|TEXTAREA)$/.test(control.tagName) && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault(); if (control.getAttribute('aria-disabled') !== 'true') control.click();
    }
  });
  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target.querySelector('.fullscreen-quiz-wrap.show')) { document.body.style.overflow = previousOverflow; clearTimeout(closeTimer); }
  });
}());
